import NBType, { InferType } from '@netbase/nb-type'
import AccountProfileInfoSchema from './AccountProfileInfoSchema'
import AuthUserRoleSchema from './AuthUserRoleSchema'
import LocalTimeZone from '../enums/LocalTimeZone'
import UserGroupSchema from './UserGroupSchema'

const UserProfileInfoSchema = NBType.object().shape('UserProfileInfoSchema', {
  /* @prop */
  accountProfile: AccountProfileInfoSchema,
  /* @prop */
  accountProfileId: NBType.number(),
  /* @prop */
  authUserRoles: NBType.array().of(AuthUserRoleSchema),
  /* @prop */
  belongUserGroups: NBType.array().of(UserGroupSchema),
  /* @prop */
  companyId: NBType.number(),
  /* @prop */
  deleted: NBType.boolean(),
  /* @prop */
  email: NBType.string(),
  /* @prop */
  id: NBType.number(),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  timeZone: NBType.enum(LocalTimeZone)
  /* END */
})
export default UserProfileInfoSchema
export type UserProfileInfo = InferType<typeof UserProfileInfoSchema>
// RESERVE BELOW
